import React from "react";

export const PlatformDocumentsPageLazy = React.lazy(() => import("./index"));
